import { render, staticRenderFns } from "./editSizeDetails.vue?vue&type=template&id=a5ba6c24"
import script from "./editSizeDetails.vue?vue&type=script&lang=js"
export * from "./editSizeDetails.vue?vue&type=script&lang=js"
import style0 from "./editSizeDetails.vue?vue&type=style&index=0&id=a5ba6c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports